export const taskActions = {
  GET_PENDING_TASKS: "GET_PENDING_TASKS",
  GET_COMPLETED_TASKS: "GET_COMPLETED_TASKS",
  DELETE_PENDING_TASK: "DELETE_PENDING_TASK",
  DELETE_COMPLETED_TASK: "DELETE_COMPLETED_TASK",
  UPDATE_PENDING_TASK: "UPDATE_PENDING_TASK",
  MOVE_TO_COMPLETED_TASKS: "MOVE_TO_COMPLETED_TASKS",
  MOVE_TO_PENDING_TASKS: "MOVE_TO_PENDING_TASKS",
  SINGLE_TASK: "SINGLE_TASK",
  SINGLE_TASK_LOADING: "SINGLE_TASK_LOADING",
  LOGOUT_USER: "LOGOUT_USER",
};
